import { Subject } from "rxjs";

const DealerLocationSubject = new Subject();

const DealerLocationService = {
  listen: () => DealerLocationSubject.asObservable(),
  copyDealerLocation: (locationMessage) =>
    DealerLocationSubject.next(locationMessage),
};

export default DealerLocationService;
